export function CompanyTypeCtrl ($scope, $uibModal, $q, workshopAPI, confirm, messages) {
  $scope.companyTypes = ['NONE', 'BRANCH', 'FRANCHISE'];
  $scope.selectedType = $scope.company.is_branch_owner ? $scope.companyTypes[1] : $scope.company.is_franchise_owner ? $scope.companyType[2] : $scope.companyTypes[0];

  $scope.save = function () {
    confirm.generic('Are you sure you’ve selected the correct type? This procedure cannot be undone.').then(function () {
        workshopAPI.patch('workshop_admin/set_multibranch_type', { company_id: $scope.company.id, multibranch_type: $scope.selectedType}).then(function (response) {
          messages.show('Save Successful!', 'success');
        });
    });
  }
}